import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "./OverallDetails.css";

class OverallDetails extends Component {
  render() {
    const { classes, classData } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Class:</b>
            <div>{classData.studentClass}</div>
          </ListItem>
        </div>
        <div className={classes.content}>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Faculty:</b>
            <div>{classData.faculty ? classData.faculty : "N/A"}</div>
          </ListItem>
        </div>
        <div className={classes.content}>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Group:</b>
            <div>{classData.group ? classData.group : "N/A"}</div>
          </ListItem>
        </div>
        <div className={classes.content}>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Section:</b>
            <div>{classData.section}</div>
          </ListItem>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(OverallDetails);
